import 'magnific-popup';
import 'magnific-popup/dist/magnific-popup.css';
import { gsap } from 'gsap';
import gsapCore from 'gsap/gsap-core';
import Scrolltrigger from 'gsap/ScrollTrigger';
gsap.registerPlugin(Scrolltrigger);
gsap.config({ nullTargetWarn: false, });


//ギャラリーページ

$('.p-gallery .popup-item').magnificPopup({
  delegate: 'a',
  type: 'image',
  closeOnBgClick: true,  // 背景クリックで閉じる機能をオフ
  showCloseBtn: false,    // デフォルトのクローズボタンを非表示
  gallery: {
    enabled: true,
    arrowMarkup: '<span title="%title%" role="button" class="gallery-arrow gallery-arrow-%dir%"></span>',
    tCounter: ''
  },
  image: {
    titleSrc: function (item) {
      return item.el.attr('title');
    }
  },
  mainClass: 'mfp-fade01',
  removalDelay: 200,
  callbacks: {
    open: function () {
      // カスタムクローズボタンをポップアップに追加
      let closeBtn = $('<button class="custom-close-btn"><span></span><span></span></button>');
      //let viewMore = $('<div class="view-more cinzel"><a href="">VIEW MORE</a></div>');
      closeBtn.appendTo(this.contentContainer);
      //viewMore.appendTo(this.contentContainer);

      // クローズボタンがクリックされたときにポップアップを閉じる
      closeBtn.on('click', function () {
        $.magnificPopup.close();
      });

    },
    markupParse: function (template, values, item) {
      // キャプションにHTMLを適用
      values.title = item.el.attr('title');
    }
  }
});



//セカンドハウスページ
if ($('body').hasClass('p-secondhouse')) {
  document.addEventListener('DOMContentLoaded', function () {
    const openModalButton = document.getElementById('openModal');
    const closeModalButton = document.getElementById('closeModal');
    const modal = document.getElementById('videoModal');
    const video = document.getElementById('conceptVideo');

    // モーダルを開き、フェードインして動画を自動再生
    openModalButton.addEventListener('click', function () {
      modal.style.display = 'block';
      gsap.to(modal, {
        autoAlpha: 1,
        duration: 0.2, // フェードインの時間
        onComplete: function () {
          video.play(); // アニメーション完了後に動画を再生
        }
      });
    });

    // モーダルを閉じ、フェードアウトして動画を停止
    function closeModal() {
      gsap.to(modal, {
        autoAlpha: 0,
        duration: 0.2, // フェードアウトの時間
        onComplete: function () {
          modal.style.display = 'none';
          video.pause();
          video.currentTime = 0; // 再生位置をリセット
        }
      });
    }

    // 閉じるボタンのクリックイベント
    closeModalButton.addEventListener('click', closeModal);

    // モーダル外をクリックして閉じる
    window.addEventListener('click', function (event) {
      if (event.target === modal) {
        closeModal();
      }
    });
  });
};
